
export class BoxesGrid {

  constructor() {
    if ($(window).width() < 480) {
      this.initSlider();
    }
  }

  initSlider() {
    $('.boxes-slider').slick({
      infinite: false,
      autoplay: false,
      arrows: false,
      swipe: true,
      speed: 350,
      fade: false,
      cssEase: 'linear',
      adaptiveHeight: true,
      dots: true,
    });
  }
}
